import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '@/components/Loader';
import useDialogConfig from '@/dialogs-routable/_hooks/useDialogConfig';
import { EventShareDialog } from '@/features/share-event';

Launcher.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default function Launcher(props) {
  const config = useDialogConfig();
  const eventId = config.params.eventId;

  // A missing eventId is valid: the dialog then lets the user pick from
  // their own active events instead of sharing a fixed one. Falling back
  // to 0 avoids the byId blueprint throwing on a missing id.
  const event = useConnect('event.byId', {
    id: eventId ?? 0
  });

  if (eventId && event.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <EventShareDialog
      event={eventId ? event : undefined}
      onCancel={props.onClose}
    />
  );
}
